import * as $ from 'jquery';
import { apiBaseUrlUser } from '../../../constants/url.constant';
import { BasicSubmitOrderModel, OrderStatus } from "../models/OrderModel";
import { DefaultService } from "../../common/services/DefaultService";

export class OrderService extends DefaultService {
    private baseUrl = `${apiBaseUrlUser}/order`;

    public RouteGet = (id: number) => `${this.baseUrl}/get/${id}`;
    public get(id: number): JQueryPromise<any> {
        return $.ajax(this.RouteGet(id), {
            type: 'get',
            contentType: 'application/json'
        });
    }

    public RouteGetList = (status: OrderStatus) => `${this.baseUrl}/getList?status=${status}`;
    public getList(status: OrderStatus): JQueryPromise<any> {
        return $.ajax(this.RouteGetList(status), {
            type: 'get',
            data: undefined,
            contentType: 'application/json'
        });
    }

    public RouteGetCountByStatus = () => `${this.baseUrl}/getCountByStatus`;
    public getCountByStatus(): JQueryPromise<any> {
        return $.ajax(this.RouteGetCountByStatus(), {
            type: 'get',
            data: undefined,
            contentType: 'application/json'
        });
    }

    public RouteGetStatusList = () => `${this.baseUrl}/getStatusList`;
    public getStatusList(): JQueryPromise<any> {
        return $.ajax(this.RouteGetStatusList(), {
            type: 'get',
            data: undefined,
            contentType: 'application/json'
        });
    }

    public RouteGetTrackingList = () => `${this.baseUrl}/getTrackingList`;
    public getTrackingList(): JQueryPromise<any> {
        return $.ajax(this.RouteGetTrackingList(), {
            type: 'get',
            data: undefined,
            contentType: 'application/json'
        });
    }

    public RouteGetReasonList = () => `${this.baseUrl}/getReasonList`;
    public getReasonList(): JQueryPromise<any> {
        return $.ajax(this.RouteGetReasonList(), {
            type: 'get',
            data: undefined,
            contentType: 'application/json'
        });
    }

    public RouteGetCheckoutSummary = (cartId: number) => `${this.baseUrl}/getCheckoutSummary/${cartId}`;
    public getCheckoutSummary(cartId: number): JQueryPromise<any> {
        return $.ajax(this.RouteGetCheckoutSummary(cartId), {
            type: 'get',
            contentType: 'application/json'
        });
    }

    public RouteSubmitOrder = () => `${this.baseUrl}/submitOrder`;
    public submitOrder(model: BasicSubmitOrderModel): JQueryPromise<any> {
        return $.ajax(this.RouteSubmitOrder(), {
            type: 'post',
            data: JSON.stringify(model),
            contentType: 'application/json'
        });
    }
}